import React from 'react';
import { Language, GameMessage } from '@/types';
import { friendlyTimestamp } from '@/lib/utils';
import { Gamepad2 } from 'lucide-react';
import { Crocodile } from './games/Crocodile';

interface GameBubbleProps {
  message: GameMessage;
  preferredLanguage: Language; // To format timestamp
}

export const GameBubble: React.FC<GameBubbleProps> = ({
  message,
  preferredLanguage,
}) => {
  const locale = preferredLanguage === "ja" ? "ja-JP" : "en-US";
  const { gameId } = message;
  return (
    <div className="message-container m-auto flex flex-col animate-fadeIn">
      <div className="flex w-fit max-w-[90%] flex-col rounded-lg shadow-md m-auto bg-cyan-900/70">
        <div className='m-2'>
          <Gamepad2 size={24} className='inline mr-2'/>{gameId}
          {gameId === 'crocodile' && <Crocodile message={message}/>}
        </div>
      </div>
      <div className="flex items-center gap-1 py-1 text-xs">
        <span className="text-neutral-500">
          {friendlyTimestamp(message.timestamp, locale)}
        </span>
      </div>
    </div>
  );
};